import React, { useEffect, useState } from "react";
import { useDrag } from "react-dnd";
import { ItemSubtypes, ItemTypes } from "../../../DnDTypes";
import styles from "./index.module.css";

// dragaMode = either 'clone' or 'move'

const BoolControl = ({
  name,
  id,
  disabled,
  isSelected = false,
  dragMode = "move",
  configuration = {},
  markSelected,
  onChange,
  showSelfDescription,
  rowIndex,
  index,
  setIsDragging,
  filledValue,
}) => {
  const [, drag] = useDrag({
    item: {
      type: ItemTypes.COMPONENT,
      subtype: ItemSubtypes.BOOL,
      dragMode,
      id,
      rowIndex,
      index,
    },
    collect: (monitor, props) => {
      setIsDragging && setIsDragging(!!monitor.isDragging());

      return {
        isDragging: !!monitor.isDragging(),
      };
    },
    canDrag: () => {
      return dragMode === "move" || dragMode === "clone";
    },
  });

  const [value, setValue] = useState(filledValue || "");
  useEffect(() => {
    setValue(filledValue);
  }, filledValue);

  const clicked = () =>
    markSelected &&
    markSelected({
      id,
      dataType: ItemSubtypes.BOOL,
      configuration,
    });

  const updateValue = (value) => {
    setValue(value);

    if (onChange) {
      onChange({
        id,
        value,
      });
    }
  };

  const placeholder = showSelfDescription ? "Tak/Nie" : configuration.label;
  return (
    <div ref={drag} className={styles.main}>
      <input
        style={{ color: disabled ? "black" : "" }}
        maxLength={configuration.size}
        disabled={disabled}
        type="checkbox"
        name={name}
        placeholder={placeholder}
        id={id}
        onClick={clicked}
        value={value}
        onChange={({ target: { value } }) => updateValue(value)}
      />
      <label>
        {placeholder}
        {configuration.required && " *"}
      </label>
    </div>
  );
};

export default BoolControl;
